import { Link } from '@cian/ui-kit';
import { IconActionChevronRightSmall16 } from '@cian/ui-kit-design-tokens/icons';
import React from 'react';

import { useOfferContext } from '../../../context';
import { isNewbuildingBookedFromDeveloper } from '../../../utils/newbuildingBooking';
import { useApplicationContext } from 'shared/utils/applicationContext';

export function BookedOfferLayoutsLinkContainer() {
  const { offer } = useOfferContext();
  const { config } = useApplicationContext();

  const isBookedFromDeveloper = isNewbuildingBookedFromDeveloper(offer);
  const isV2BookedFromDeveloperEnabled = config.get<boolean>('Newbuilding.BookedFromDeveloperDesktop.Enabled');
  const isBookedFromDeveloperAvaliable = Boolean(isBookedFromDeveloper && isV2BookedFromDeveloperEnabled);

  if (!isBookedFromDeveloperAvaliable) {
    return null;
  }

  return (
    <div>
      <Link
        fontWeight="bold"
        fontSize="L"
        spacingSize="M"
        data-testid="booked-offer-layouts-link"
        href={`${offer.fullUrl}#booked-offer-layouts`}
        target="_blank"
        afterIcon={<IconActionChevronRightSmall16 color="icon-main-default" />}
      >
        Посмотреть похожие квартиры
      </Link>
    </div>
  );
}
